<style scoped lang="sass">
.contact
  padding-left: 16px
  padding-right: 16px
  padding-bottom: 60px !important
  background: #fff

.footer_bar_absolute
  font-weight: bold

.phone
  display: flex
  align-items: center
  justify-content: space-between

  .country_select_box
    align-self: flex-end
    display: flex
    justify-content: center
    align-items: center
    width: 130px
    height: 56px
    margin-right: 12px
    background: #F7F7F7

  .phone_num
    flex: 1

::v-deep
  .van-button--primary
    background-color: var(--menu-primary-background-colour)

  .push-from-bottom
    bottom: 18px !important

  .multiselect__tags
    padding-top: 15px
    background: #F7F7F7 !important
    border: none

  .multiselect__select
    padding-top: 15px

  .py_form_item_box
    padding: 20px 0 0 0

  .i-form-item-message
    bottom: -18px !important
    color: #B00020 !important

  input
    color: var(--menu-primary-text-colour) !important
    font-weight: 400

  .icon
    font-size: 25px

.order_detail
  display: flex
  flex-direction: column
  align-content: center
  justify-content: center
  align-items: center

  .num
    margin-top: 15px
    margin-bottom: 15px
    background: #32383E05

  .multi_store_note
    margin-top: -8px
    margin-bottom: 15px
    text-align: center
    font: normal normal normal 12px/16px Roboto
    letter-spacing: 0px
    color: var(--menu-primary-text-colour)

  .venue_section
    background: #32383E05 0% 0% no-repeat padding-box
    border: 1px solid #32383E1A
    border-radius: 4px
    width: 90%
    text-align: center
    margin-bottom: 25px

    .venue_name
      display: flex
      flex-direction: row
      flex-wrap: nowrap
      align-content: center
      justify-content: space-between
      align-items: center
      min-height: 40px
      background: #32383E05 0% 0% no-repeat padding-box

      .text
        font: normal normal bold 14px/18px Roboto
        letter-spacing: 0
        color: #000000

      .status
        width: 69px
        height: 23px
        background: #46D666 0% 0% no-repeat padding-box
        border-radius: 12px
        text-align: center
        font: normal normal bold 12px/16px Roboto
        letter-spacing: -0.45px
        color: #FFFFFF
        display: flex
        flex-wrap: nowrap
        align-content: center
        justify-content: center
        align-items: center

      .yellow
        background-color: #FFCE00

      .dark_green
        background-color: #12501e

    .collect_section
      text-align: left
      margin: 10px

      .title
        font: normal normal bold 12px/16px Roboto
        letter-spacing: 0px

      .display_content
        font: normal normal normal 12px/16px Roboto
        letter-spacing: 0px

    .store_order_no
      text-align: left
      margin: 10px
      font: normal normal bold 13px/18px Roboto
      letter-spacing: 0px
      color: var(--menu-primary-background-colour)

    ::v-deep
      .order_item_collapse
        .title
          text-align: left
          font-weight: bold
          margin-left: -8px
          font: normal normal bold 12px/16px Roboto
          color: var(--menu-primary-background-colour)

        .items
          padding-left: 0
          padding-right: 0

        .left
          margin-right: 5px

.text
  margin-left: 10px

.ns
  margin-top: 14px

.email_input
  ::v-deep
    .box
      .label
        &.wrong
          color: rgba(51, 68, 85, 0.45) !important
</style>

<template lang="pug">
  .order_detail(v-if="showOrderStatus && order")
    Num.num(:createdAt="order.createdAtString" :orderNo="order.orderNo")
    .multi_store_note(v-if="hasStoreNumbers") {{ t('show_each_store_note', 'Show each store its own number when you collect.') }}

    .venue_section(v-if="order.generalMessage && hasRichContent(order.generalMessage.message)")
      .collect_section
        .title {{ t('how_to_collect_general', 'How to collect (General)') }}
        .display_content(v-html="renderRichText(order.generalMessage.message)")

    .venue_section(v-for="(venueOrders, venueIdIndex) in order.orderList")
      .venue_name
        .text {{ venueOrders[0].venueName }}
        .status(:class="getStatusClass(venueOrders[0].status)") {{ getStatusName(venueOrders[0].status) }}
      .store_order_no(v-if="hasStoreNumbers && storeNo(venueIdIndex)") {{ t('store_order_number', 'Order number') }} {{ '#' }}{{ storeNo(venueIdIndex) }}
      collapse.order_item_collapse(
        :title="t('order_details', 'Order Details')"
        :name="venueIdIndex"
        :id="venueIdIndex"
        :index="collapseShowList[venueIdIndex]"
        @change="collapseShowList[venueIdIndex] = $event"
      )
        Items(
          v-for="item in venueOrders[0].itemList"
          :key="item.id"
          :data="item"
          :isPostPaid="false"
          :showMoney="false"
        )
      .collect_section(v-if="hasRichContent(getOrderCollectionInfo(venueOrders[0]))")
        .title {{ t('how_to_collect', 'How to collect') }}
        .display_content(v-html="renderRichText(getOrderCollectionInfo(venueOrders[0]))")

  .contact_box(v-else)
    py-form.contact.overflow_scroll(
      ref="form"
      id="scroll_bar"
      :model="userInfo"
      :rules="ruleValidate"
    )
      .user_name
        py-form-item.phone_num(prop='userName')
          py-input(
            v-model="userInfo.userName"
            :title="t('name', 'Name')"
            type="text"
            isContact
            icon="person"
            size="25"
            @pyBlur="val => userInfo.userName = userInfo.userName.trim()"
            @focus="clearValidate(0)"
          )
      .phone
        .country_select_box
          CountrySelect.select(
            v-model="country"
            :countriesList="countriesList"
          )

        py-form-item.phone_num(prop='phoneNumber')
          py-input(
            v-model="userInfo.phoneNumber"
            :title="t('phone_number', 'Phone number')"
            type="number"
            isContact
            :size="25"
            icon="phone_iphone"
            @input="val => userInfo.phoneNumber = userInfo.phoneNumber.trim()"
            @focus="clearValidate(1)"
          )
      main-text.ns(
        :detail="phoneDetail"
      )
      py-form-item(prop='emailNumber')
        py-input.email_input(
          v-model="userInfo.emailNumber"
          maxlength="50"
          type="email"
          :title="email"
          isContact
          :size="25"
          @focus="clearValidate(2)"
          @pyBlur="val => userInfo.emailNumber = userInfo.emailNumber.trim()"
        )
      main-text.ns(
        :detail="emailDetail"
      )
    footer-common.footer_bar_absolute(
      @clickButton="checkOrderDetail()"
    )
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import MainText from '@/views/contact-details/component/MainText'
import CountrySelect from 'components/CountrySelect'
import { getUser, getOrder } from '@/api/product'
import { mapState } from 'vuex'
import countriesList from '@/plugins/countries'
import parsePhoneNumber from 'libphonenumber-js'
import Collapse from 'components/Collapse'
import Num from 'views/pay/component/Num'
import Items from 'views/pay/component/Items'
import { t } from '@/utils/language'
import { sanitizeRichText } from '@/utils/richtext/sanitizeRichText'
import { richTextHasContent } from '@/utils/richtext/richTextContent'
import { hasStoreOrderNumbers, storeOrderNo, shortOrderNo } from '@/views/venue-sub-group/storeOrderNumbers'

const emailNumberRule = (rule, value, callback) => {
  const reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
  if (!reg.test(value)) {
    callback(new Error('Please provide a vaild email adddress'))
  }
  callback()
}

const phoneNumberRule = (rule, value, callback) => {
  value = value.trim()
  const reg = /^\d{1,}$/
  if (isNaN(value)) {
    callback(new Error('PhoneNumber format is incorrect'))
  }
  if (!reg.test(value)) {
    callback(new Error('Required'))
  }
  if (value.length < 6) {
    callback(new Error('PhoneNumber is greater than 6'))
  }
  if (value.length > 14) {
    callback(new Error('PhoneNumber is greater less than 14'))
  }
  callback()
}

// User name input box, form verification rules
// 用户名称输入框，表单校验规则
const userNameRule = (rule, value, callback) => {
  if (!value.trim()) {
    callback(new Error('Required'))
  }
  callback()
}

@Component({
  props: {
    venueSubGroupId: {
      type: String,
    },
    orderId: {
      type: String,
    },
    venueId: {
      type: String,
    }
  },

  computed: {
    ...mapState({
      venueCountry: state => state.venueHome.venueCountry,
    }),

    padding() {
      return this.$store.state.app.request
    },

    email() {
      const _lang = this.$lang // eslint-disable-line no-unused-vars
      return t('email_address', 'Email address')
    },
    phoneDetail() {
      const _lang = this.$lang // eslint-disable-line no-unused-vars
      return t('required_to_identify', 'Required to identify your order & provide order updates.') + ' ' + t('not_used_for_marketing', 'It will not be used for marketing.')
    },
    emailDetail() {
      const _lang = this.$lang // eslint-disable-line no-unused-vars
      return t('email_for_tax_receipt', 'Your email will only be used to send you a tax receipt.')
    },
  },

  watch: {
    padding(val) {
      if (this.userId || this.notificationKey) {
      } else {
        this.$store.commit('closeLoading')
      }
    },
  },

  components: {
    MainText,
    CountrySelect,
    Collapse,
    Num,
    Items
  }
})

class OrderStatus extends Vue {
  t(key, fallback) {
    const _lang = this.$lang // eslint-disable-line no-unused-vars
    return t(key, fallback)
  }

  showOrderStatus = false
  order = null
  country = {}
  countriesList = countriesList
  collapseShowList = {}

  ruleValidate = {
    phoneNumber: [
      {
        validator: phoneNumberRule,
        trigger: 'blur'
      }
    ],
    emailNumber: [
      {
        required: true,
        message: t('required', 'Required'),
        trigger: 'blur'
      },
      {
        validator: emailNumberRule,
        trigger: 'blur'
      }
    ],
    userName: [
      {
        validator: userNameRule,
        trigger: 'blur'
      },
    ],
  }

  userInfo = {
    phoneNumber: '',
    emailNumber: '',
    userName: '',
  }

  userId = ''
  notificationKey = ''
  setTimeout = null

  /**
   * Clear form validation when the input box gets focus
   * @param {Number} index Index of the current form item
   */
  /**
   * 输入框获取焦点时，清除表单验证
   * @param {Number} index 当前表单项的索引
   */
  clearValidate(index) {
    this.$refs.form.fields[index]._clearValidate()
  }

  async created() {
    this.$store.commit('showLoading')
    if (this.orderId) {
      await this.__startGetOrder()
    } else {
      await this.__checkVenueOpenTime()
    }
  }

  checkOrderDetail(val) {
  }

  _getCountry() {
    return this.countriesList.filter(item => {
      if (item.code.toLowerCase() === this.venueCountry.toLowerCase()) {
        return item
      }
    })
  }

  beforeDestroy() {
    if (this.setTimeout) {
      clearTimeout(this.setTimeout)
    }
  }

  async mounted() {
    this.userId = localStorage.getItem('userId') || ''
    this.notificationKey = localStorage.getItem('notificationKey') || ''
    if (this.userId || this.notificationKey) {
      await this._getUserInfo()
    } else {
      this.country = this._getCountry()[0]
      this.$store.commit('closeLoading')
    }
  }

  async __startGetOrder() {
    if (this.orderId && this.venueSubGroupId) {
      this.showOrderStatus = true
      await this._updateOrderStatus()
    } else if (this.orderId && this.venueId) {
      this.showOrderStatus = true
      await this._updateOrderStatus()
    } else {
      this.showOrderStatus = false
    }
  }

  async _updateOrderStatus() {
    await this._getOrder()
    this.setTimeout = setTimeout(_ => {
      this._updateOrderStatus()
    }, 10000)
  }

  async _getOrder() {
    try {
      const res = await getOrder({
        id: this.orderId,
        venueSubGroupId: this.venueSubGroupId,
        venueId: this.venueId
      })

      this.order = { ...res }
      if (res.orderList) {
        for (const venueOrderList in res.orderList) {
          if (this.collapseShowList[venueOrderList[0].venueId] !== venueOrderList[0].venueId) {
            this.collapseShowList[venueOrderList] = ''
          }
        }
      } else if (!res.venueSubGroupId) {
        if (!this.collapseShowList[this.venueId]) this.collapseShowList[this.venueId] = this.venueId
        this.order.orderList = {
          [this.venueId]: [{ ...res, venueName: this.$store.state.navTitle.venueName }]
        }
      }
      return res
    } catch {
      this.$store.commit('closeLoading')
    }
  }

  // Get user information
  // 获取用户信息
  async _getUserInfo() {
    const res = await getUser({
      id: this.userId,
      notificationKey: this.notificationKey
    }).catch(function (error) {
      console.log(error)
    })
    if (res && res.name) {
      const parsePhone = parsePhoneNumber(res.phone)
      if (parsePhone && parsePhone.countryCallingCode) {
        this.country = this.countriesList.find(item => item.dial_code === `+${parsePhone.countryCallingCode}`)
        this.userInfo.phoneNumber = parsePhoneNumber(res.phone).nationalNumber
      }
      this.userInfo.emailNumber = res.email
      this.userInfo.userName = res.name
      if (!this.userId) {
        this.userId = res.id
        localStorage.setItem('userId', res.id)
        this.$store.commit('addUserProp', {
          prop: 'id',
          val: res.id
        })
      }
    }
    this.$store.commit('closeLoading')
  }

  getStatusName(status) {
    if (parseInt(status) === 30) {
      return t('ready', 'Ready')
    } else if (parseInt(status) >= 40) {
      return t('picked_up', 'Picked Up')
    } else {
      return t('preparing', 'Preparing')
    }
  }

  getStatusClass(status) {
    if (parseInt(status) === 30) {
      return 'green'
    } else if (parseInt(status) >= 40) {
      return 'dark_green'
    } else {
      return 'yellow'
    }
  }

  getOrderCollectionInfo(orderInfo) {
    return orderInfo.venueCollectionMessage ?? ''
  }

  // 取餐说明由管理端富文本编辑器产出,可能带 HTML 标签(<p>/&nbsp; 等)。
  // 净化后 v-html 渲染,避免把标签当纯文本原样显示给顾客,同时挡住存储型 XSS。
  renderRichText(html) {
    return sanitizeRichText(html)
  }

  // 富文本说明判空:空 / 只剩 <p></p>、<p>&nbsp;</p> 之类残留时整段不渲染。
  hasRichContent(html) {
    return richTextHasContent(html)
  }

  // 跨组 sub group 门控:任一店展示的成员号 ≠ 父号 → 整单每店展示自己的取餐号。
  // type=0 恒 false(后端父/子同号不变量),顾客端零变化。
  get hasStoreNumbers() {
    return hasStoreOrderNumbers(this.order)
  }

  // 某店的短取餐号(取 '_' 后末段);缺失返回 ''。
  storeNo(venueId) {
    return shortOrderNo(storeOrderNo(this.order, venueId))
  }
}
export default OrderStatus
</script>
